import { Breakpoints } from '@doordash/design-language';
export var WIDESCREEN_BREAKPOINT = Breakpoints.WideScreen;
export var DESKTOP_BREAKPOINT = Breakpoints.Desktop;
export var TABLET_BREAKPOINT = Breakpoints.Tablet;
export var MediaQuery;
(function (MediaQuery) {
    MediaQuery["widescreen"] = "widescreen";
    MediaQuery["desktop"] = "desktop";
    MediaQuery["tablet"] = "tablet";
    MediaQuery["mobile"] = "mobile";
})(MediaQuery || (MediaQuery = {}));
var MediaQueryWatcher = /** @class */ (function () {
    function MediaQueryWatcher() {
        this.currentMediaQuery = screenWidthToMediaQuery(getScreenWidth());
        this.listeningMediaQueries = false;
        this.callbackHandlers = [];
    }
    MediaQueryWatcher.prototype.getMediaQuery = function () {
        return this.currentMediaQuery;
    };
    MediaQueryWatcher.prototype.onScreenResize = function () {
        var newMediaQuery = screenWidthToMediaQuery(getScreenWidth());
        if (this.currentMediaQuery !== newMediaQuery) {
            this.currentMediaQuery = newMediaQuery;
            this.triggerCallbackHandlers();
        }
    };
    MediaQueryWatcher.prototype.triggerCallbackHandlers = function () {
        var _this = this;
        this.callbackHandlers.forEach(function (cb) { return cb(_this.currentMediaQuery); });
    };
    MediaQueryWatcher.prototype.watchMediaQuery = function (callbackHandler) {
        var _this = this;
        this.callbackHandlers.push(callbackHandler);
        if (!this.listeningMediaQueries) {
            this.listeningMediaQueries = true;
            window.addEventListener('resize', function () { return _this.onScreenResize(); });
            this.onScreenResize();
        }
    };
    MediaQueryWatcher.prototype.stopWatchingMediaQuery = function (callbackHandler) {
        this.callbackHandlers.splice(this.callbackHandlers.indexOf(callbackHandler), 1);
    };
    return MediaQueryWatcher;
}());
export default MediaQueryWatcher;
export var screenWidthToMediaQuery = function (width) {
    if (width >= WIDESCREEN_BREAKPOINT) {
        return MediaQuery.widescreen;
    }
    if (width >= DESKTOP_BREAKPOINT) {
        return MediaQuery.desktop;
    }
    if (width >= TABLET_BREAKPOINT) {
        return MediaQuery.tablet;
    }
    return MediaQuery.mobile;
};
/**
 * DM-MIGRATE, make SSR friendly. On server we return mobile
 */
export var getScreenWidth = function () {
    if (typeof window === 'undefined') {
        return Breakpoints.Mobile;
    }
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};
